import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { addClass, removeClass } from '../_utils/class';
import CustomKeyboard from './CustomKeyboard';
let instanceArr = [];
let customNumberKeyboard = null;
class InputKeyBoard extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (value) => {
            if (!('value' in this.props)) {
                this.setState({ value: value.target.value });
            }
            this.props.onChange(value);
        };
        this.onConfirm = (value) => {
            this.props.onVirtualKeyboardConfirm(value);
        };
        this.addBlurListener = () => {
            document.addEventListener('click', this.doBlur, false);
        };
        this.removeBlurListener = () => {
            document.removeEventListener('click', this.doBlur, false);
        };
        this.saveRef = (el) => {
            if (el) {
                customNumberKeyboard = el;
                instanceArr.push({ el, container: this.container });
            }
        };
        this.doBlur = (ev) => {
            // 处理input-verify-code焦点bug
            if (this.props.disableAutoHidden)
                return;
            const { value } = this.state;
            if (ev.target !== this.inputRef) {
                this.onInputBlur(value);
            }
        };
        this.removeCurrentExtraKeyboard = () => {
            instanceArr = instanceArr.filter((item) => {
                const { el, container } = item;
                if (el && container && el !== customNumberKeyboard && container.parentNode) {
                    container.parentNode.removeChild(container);
                }
                return el === customNumberKeyboard;
            });
        };
        this.unLinkInput = () => {
            if (customNumberKeyboard &&
                customNumberKeyboard.antmKeyboard &&
                customNumberKeyboard.linkedInput &&
                customNumberKeyboard.linkedInput === this) {
                customNumberKeyboard.linkedInput = null;
                addClass(customNumberKeyboard.antmKeyboard, `${this.props.keyboardPrefixCls}-wrapper-hide`);
            }
            // for unmount
            this.removeBlurListener();
            // this.removeCurrentExtraKeyboard();
        };
        this.onInputBlur = (value) => {
            const { focus } = this.state;
            if (focus) {
                this.setState({
                    focus: false,
                });
                this.props.onBlur(value);
                setTimeout(() => {
                    this.unLinkInput();
                }, 50);
            }
        };
        this.onInputFocus = () => {
            const { value } = this.state;
            this.props.onFocus(value);
            this.setState({
                focus: true,
            }, () => {
                if (customNumberKeyboard) {
                    customNumberKeyboard.linkedInput = this;
                    if (customNumberKeyboard.antmKeyboard) {
                        removeClass(customNumberKeyboard.antmKeyboard, `${this.props.keyboardPrefixCls}-wrapper-hide`);
                    }
                    // customNumberKeyboard.confirmDisabled = value === '';
                    if (customNumberKeyboard.confirmKeyboardItem) {
                        if (value === '') {
                            // addClass(
                            //   customNumberKeyboard.confirmKeyboardItem,
                            //   `${this.props.keyboardPrefixCls}-item-disabled`,
                            // );
                        }
                        else {
                            removeClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                        }
                    }
                }
            });
        };
        this.onKeyboardClick = (KeyboardItemValue) => {
            const { maxLength } = this.props;
            const { value } = this.state;
            // tslint:disable-next-line:no-this-assignment
            const { onChange } = this;
            let valueAfterChange;
            // 删除键
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
                // 确认键
            }
            else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                this.onInputBlur(valueAfterChange);
                this.onConfirm(valueAfterChange);
                // 收起键
            }
            else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                this.onInputBlur(valueAfterChange);
            }
            else {
                if (maxLength !== undefined &&
                    +maxLength >= 0 &&
                    (value + KeyboardItemValue).length > maxLength) {
                    valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                    onChange({ target: { value: valueAfterChange } });
                }
                else {
                    valueAfterChange = value + KeyboardItemValue;
                    onChange({ target: { value: valueAfterChange } });
                }
            }
            if (customNumberKeyboard) {
                // customNumberKeyboard.confirmDisabled = valueAfterChange === '';
                if (customNumberKeyboard.confirmKeyboardItem) {
                    if (valueAfterChange === '') {
                        // addClass(
                        //   customNumberKeyboard.confirmKeyboardItem,
                        //   `${this.props.keyboardPrefixCls}-item-disabled`,
                        // );
                    }
                    else {
                        removeClass(customNumberKeyboard.confirmKeyboardItem, `${this.props.keyboardPrefixCls}-item-disabled`);
                    }
                }
            }
        };
        this.onFakeInputClick = () => {
            this.focus();
        };
        this.focus = () => {
            // this focus may invocked by users page button click, so this click may trigger blurEventListener at the same time
            this.removeBlurListener();
            const { focus } = this.state;
            if (!focus) {
                this.onInputFocus();
            }
            setTimeout(() => {
                this.addBlurListener();
            }, 50);
        };
        this.getInputRef = (el) => {
            this.inputRef = el;
            if (this.props.autoFocus) {
                this.focus();
            }
        };
        this.state = {
            focus: false,
            value: props.value || props.defaultValue,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== undefined) {
            return {
                value: nextProps.value,
                focus: prevState.focus,
            };
        }
        return null;
    }
    componentWillUnmount() {
        // focus:true unmount 不能触发 blur
        if (this.state.focus) {
            this.props.onBlur(this.state.value);
        }
        this.unLinkInput();
    }
    getComponent() {
        const { confirmLabel, backspaceLabel, keyboardPrefixCls, keyboardWrapProps, keyboardHeader, keyBoardValueList, } = this.props;
        return (<CustomKeyboard ref={this.saveRef} onClick={this.onKeyboardClick} prefixCls={keyboardPrefixCls} confirmLabel={confirmLabel} backspaceLabel={backspaceLabel} wrapProps={keyboardWrapProps} header={keyboardHeader} keyList={keyBoardValueList}/>);
    }
    getContainer() {
        const { keyboardPrefixCls } = this.props;
        if (!this.container) {
            const container = document.createElement('div');
            container.setAttribute('id', `${keyboardPrefixCls}-container-${(new Date().getTime())}`);
            document.body.appendChild(container);
            this.container = container;
        }
        return this.container;
    }
    render() {
        const { placeholder, disabled, editable, keyboardAlign, className } = this.props;
        const { focus, value } = this.state;
        const preventKeyboard = disabled || !editable;
        const fakeInputCls = classnames(`cfm_keyboard-input`, {
            focus,
            'cfm_keyboard-input-disabled': disabled,
        });
        const fakeInputContainerCls = classnames('cfm_keyboard-input-container', {
            'cfm_keyboard-input-container-left': keyboardAlign === 'left',
        }, className);
        return (<div className={fakeInputContainerCls}>
        {value === '' && (
        // tslint:disable-next-line:jsx-no-multiline-js
        <div className="cfm_keyboard-input-placeholder">{placeholder}</div>)}
        <div role="textbox" aria-label={value || placeholder} className={fakeInputCls} ref={this.getInputRef} onClick={preventKeyboard ? () => { } : this.onFakeInputClick}>
          {value}
        </div>
        {ReactDOM.createPortal(this.getComponent(), this.getContainer())}
      </div>);
    }
}
InputKeyBoard.defaultProps = {
    onChange: () => { },
    onFocus: () => { },
    onBlur: () => { },
    onVirtualKeyboardConfirm: () => { },
    defaultValue: '',
    placeholder: '',
    disabled: false,
    editable: true,
    prefixCls: 'cfm_input',
    keyboardPrefixCls: 'cfm_num_keyboard',
    keyboardAlign: 'left',
    disableAutoHidden: false,
    autoFocus: false,
};
export default InputKeyBoard;



// WEBPACK FOOTER //
// ./components/input-key-board/index.tsx